module.exports = __webpack_public_path__ + "img/kachel-einzelneprodukte_SUPEROMEGA.33ceb790.png";